import React from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";

import "./i18n";
import App from "./App";
import { initSentryForProdVyprvpn } from "./utils/sentry";

initSentryForProdVyprvpn();

const tagManagerArgs = {
  gtmId: "GTM-N6WV53J",
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(<App />, document.getElementById("root"));
